require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';

import VTooltipPlugin from 'v-tooltip';
import Toast, { PluginOptions } from "vue-toastification";
import VueScrollTo from "vue-scrollto";
import PrimeVue from 'primevue/config';
import Particles from 'particles.vue3';

import "vue-toastification/dist/index.css";
import 'v-tooltip/dist/v-tooltip.css';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({el, app, props, plugin}){
        return createApp({render: () => h(app, props)})
            .use(plugin)
            .use(VTooltipPlugin) //todo consider using primevue tooltip - but this works (weird behavior with long texts tho)
            .use(VueScrollTo)
            .use(Toast, {})
            .use(PrimeVue)
            .use(Particles)
            .mixin({methods: {route}})
            .mount(el);
    },
});

/**
 * Need later version to fix event.detail = null bug
 * */
InertiaProgress.init({
    // The delay after which the progress bar will
    // appear during navigation, in milliseconds.
    delay: 0,

    // The color of the progress bar.
    color: '#29d',

    // Whether to include the default NProgress styles.
    includeCSS: true,

    // Whether the NProgress spinner will be shown.
    showSpinner: false,
});

